import { FRONTEND_LINK } from "../constants/constants";
import { TwitterAccessScopeEnum } from "@libs/shared/enums/social.enum";
import { PromptTypeEnum } from "@libs/shared/db/enums/social-prompt.enum";
import WALLET from "../assets/images/login_vip.svg";
import DISCORD from "../assets/images/discord_img.svg";
import TWITTER from "../assets/images/twitter_img.svg";
import TELEGRAM from "../assets/images/telegram_logo.svg";
import EMAIL from "../assets/images/mark_email.svg";
import TRADE from "../assets/images/trade_horiz.svg";
import NOTES from '../assets/images/account_box.svg';

export enum TwitterActionEnum {
  Tweet = 0,
  Follow = 1,
  Reply = 2,
  Retweet = 3,
  Like = 4,
};

export enum CompanyActionEnum {
  Login = 5,
  Email = 6,
  Deposit = 7,
  Trade = 8,
  AffiliatePoints = 11
};

export enum TelegramActionEnum {
  Join = 9
};

export enum DiscordActionEnum {
  Join = 10
};

export const NON_REPEATABLE_ACTIONS = [
  TwitterActionEnum.Follow, 
  CompanyActionEnum.Login, 
  CompanyActionEnum.Email, 
  TelegramActionEnum.Join, 
  DiscordActionEnum.Join
];

export enum AppEnum {
  Company = "COMPANY",
  Discord = "DISCORD",
  Twitter = "TWITTER",
  Telegram = "TELEGRAM"
};

export enum AppNames {
  'DISCORD' = "Discord",
  'TWITTER' = "X",
  'TELEGRAM' = "Telegram",
}

export enum ITACKS {
  avaliable = "avaliable",
  completed = "completed"
}

export const PointLinks = {
  [AppEnum.Twitter]: "https://x.com",
  [AppEnum.Discord]: "https://discord.com/invite/Mstk57yxJQ",
  [AppEnum.Telegram]: "https://t.me",
  [AppEnum.Company]: FRONTEND_LINK,

}

export const PointIcons = {
  [AppEnum.Twitter]: TWITTER,
  [AppEnum.Discord]: DISCORD,
  [AppEnum.Telegram]: TELEGRAM,
  [AppEnum.Company]: {
    [CompanyActionEnum.Login]: WALLET,
    [CompanyActionEnum.Trade]: TRADE,
    [CompanyActionEnum.Deposit]: WALLET,
    [CompanyActionEnum.Email]: EMAIL,
    [CompanyActionEnum.AffiliatePoints]: NOTES
  }
}

export const TasksText = {
  [AppEnum.Twitter]: {
    [TwitterActionEnum.Tweet]: "points_tasks.task_x_0",
    [TwitterActionEnum.Follow]: "points_tasks.task_x_1",
    [TwitterActionEnum.Reply]: "points_tasks.task_x_2",
    [TwitterActionEnum.Retweet]: "points_tasks.task_x_3",
    [TwitterActionEnum.Like]: "points_tasks.task_x_4",
  },
  [AppEnum.Company]: {
    [CompanyActionEnum.Login]: "points_tasks.task_company_1",
    [CompanyActionEnum.Trade]: "points_tasks.task_company_2",
    [CompanyActionEnum.Email]: "points_tasks.task_company_3",
    [CompanyActionEnum.Deposit]: "points_tasks.task_company_4",
    [CompanyActionEnum.AffiliatePoints]: "points_tasks.task_company_5",
  },
  [AppEnum.Telegram]: {
    [TelegramActionEnum.Join]: "points_tasks.task_telegram_1"
  },
  [AppEnum.Discord]: {
    [DiscordActionEnum.Join]: "points_tasks.task_discord_1"
  }
}

export const HistoryText = {
  [AppEnum.Twitter]: {
    [TwitterActionEnum.Tweet]: "points_tasks.history_x_0",
    [TwitterActionEnum.Follow]: "points_tasks.history_x_1",
    [TwitterActionEnum.Reply]: "points_tasks.history_x_2",
    [TwitterActionEnum.Retweet]: "points_tasks.history_x_3",
    [TwitterActionEnum.Like]: "points_tasks.history_x_4",
  },
  [AppEnum.Company]: {
    [CompanyActionEnum.Login]: "points_tasks.history_company_1",
    [CompanyActionEnum.Trade]: "points_tasks.history_company_2",
    [CompanyActionEnum.Email]: "points_tasks.history_company_3",
    [CompanyActionEnum.Deposit]: "points_tasks.history_company_4",
    [CompanyActionEnum.AffiliatePoints]: "points_tasks.task_company_5",
  },
  [AppEnum.Telegram]: {
    [TelegramActionEnum.Join]: "points_tasks.history_telegram_1"
  },
  [AppEnum.Discord]: {
    [DiscordActionEnum.Join]: "points_tasks.history_discord_1"
  }
}

export const TimeEstimationText = {
  [AppEnum.Twitter]: {
    [TwitterActionEnum.Tweet]: "points_tasks.estimation_instantly",
    [TwitterActionEnum.Follow]: "points_tasks.estimation_hour",
    [TwitterActionEnum.Reply]: "points_tasks.estimation_hour",
    [TwitterActionEnum.Retweet]: "points_tasks.estimation_after_exp",
    [TwitterActionEnum.Like]: "points_tasks.estimation_after_exp",
  },
  [AppEnum.Company]: {
    [CompanyActionEnum.Login]: "points_tasks.estimation_instantly",
    [CompanyActionEnum.Trade]: "points_tasks.estimation_trades",
    [CompanyActionEnum.Email]: "points_tasks.estimation_instantly",
    [CompanyActionEnum.Deposit]: "points_tasks.estimation_trades",
    [CompanyActionEnum.AffiliatePoints]: "points_tasks.ectimation_affiliate",
  },
  [AppEnum.Telegram]: {
    [TelegramActionEnum.Join]: "points_tasks.estimation_instantly"
  },
  [AppEnum.Discord]: {
    [DiscordActionEnum.Join]: "points_tasks.estimation_instantly"
  }

}

export interface Leaderboard {
  address: string,
  discord?: string,
  twitter?: string,
  telegram?: string,
  tasksCompleted: number,
  currentPoints: number,
  order: number
};

export interface Tweet {
  id: string,
  createdAt: Date,
  expiresAt: Date,
  text?: string,
};

export interface PointsAction {
  id: number,
  name: string,
  points: number
  source: AppEnum
};

export interface TweetAction {
  id: number,
  text?: string
}

export interface PointsTask {
  source: AppEnum,
  points: number,
  id: number,
  createdAt?: Date,
  expiresAt?: Date,
  count?: number,
  referenceId?: string,
  tweetTxt?: string,
  completedActions?: number[];
}

export interface SocialAccount {
  address: string;
  points: number;
  email: string | null;
  twitterAccount: null | {
    userName: string;
    twitterId: string;
    name: string;
    permissions: TwitterAccSettings;
  },
  discordAccount: null | {
    userName: string;
    discordId: string;
    name: string;
  },
  telegramAccount: null | {
    userName: string;
    telegramId: string;
  }
}

export interface PointsSettings {
  isShowUltradePoints: boolean,
  discordEnabled?: boolean,
  telegramEnabled?: boolean,
  telegramBotName?: string,
  telegramBotId?: string,
  telegramGroupId?: string,
  telegramGroupName?: string,
  twitterEnabled?: boolean,
  twitterJobEnabled?: boolean,
  twitterAccountId?: string,
  twitterAccountName?: string,
  guideLink?: string,
}

export interface TwitterAccSettings {
  canFollowAccounts: boolean;
  canCreateTweets: boolean;
  canLikeTweets: boolean;
}

export interface Unlock {
  id: number;
  name: string;
  description: string;
  points: number;
}

export interface TelegramData {
  auth_date: number;
  id: number;
  first_name: string;
  hash: string;
  photo_url: string;
  username: string;
}

export interface AppData {
  twitActions: PointsAction[],
  tasks: PointsTask[]
}

export enum TwitterScopeEnum {
  canFollowAccounts = TwitterAccessScopeEnum.FOLLOWS_WRITE,
  canCreateTweets = TwitterAccessScopeEnum.TWEET_WRITE,
  canLikeTweets = TwitterAccessScopeEnum.LIKE_WRITE,
}

export interface IPrompt {
  id: number, 
  title: string, 
  enabled?: boolean,
  type: PromptTypeEnum
}
export interface ISeason {
  status: SeasonStatusEnum,
  endDate: Date | null,
  name: string,
  points: number,
  tasksCompleted: number,
  leaderboardPosition: number,
  unlocksAchieved: number
}

export interface IActiveSeason {
  id: number,
  startDate: Date,
  endDate: Date | null,
  name: string,
  status: SeasonStatusEnum
}

export enum SeasonStatusEnum {
  CREATED = 'created',
  STARTED = 'started',
  PAUSED = 'paused',
  CLOSED = 'closed',
}

export interface TabData  {
  season: IActiveSeason | null;
  tasks: PointsTask[];
  leaders: Leaderboard[];
  unlocks: Unlock[];
  XActions: PointsAction[];
}